export function isAllChecked (options) {
  return isAllSelectorChecked(options) || isAllOptionsIndividuallyChecked(options)
}

export function isAllOptionsIndividuallyChecked (options) {
  return options
    .filter(option => !option.selectAll) // ignore the 'all selector'
    .map(option => !!option.checked) // look at 'checked' (normalized)
    .reduce((acc, val) => acc && val, true) // are all of them true?
}

function isAllSelectorChecked (options) {
  const allSelector = getAllSelector(options)
  return allSelector && allSelector.checked
}

export function getAllSelector (options) {
  let allSelector = options.filter(option => option.selectAll)
  return allSelector.length > 0 ? allSelector[0] : undefined
}

/*
 Our props.value can't be an array because it is passed down to react-select.js which has this propTypes:
   value: _react2['default'].PropTypes.object.isRequired
 so to avoid a console warning we have to wrap the value array when calling our <Select>
 here we unwrap it. */
export function unwrapOptions (optionsObj) {
  return optionsObj.options
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Select/MultiUtils.js